import React from "react";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { profile } from "../data/profile";
import "../App.css";

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg fixed-top navbar-dark site-navbar px-3 px-lg-4">
      <div className="container-fluid site-section-inner">
        <Link className="navbar-brand" to="/">
          {profile.name}
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-1">
            <li className="nav-item">
              <HashLink smooth to="/#about" duration={500} className="nav-link">
                About
              </HashLink>
            </li>
            <li className="nav-item">
              <HashLink smooth to="/#experience" duration={500} className="nav-link">
                Experience
              </HashLink>
            </li>
            <li className="nav-item">
              <HashLink smooth to="/#education" duration={500} className="nav-link">
                Education
              </HashLink>
            </li>
            <li className="nav-item">
              <HashLink smooth to="/#projects" duration={500} className="nav-link">
                Projects
              </HashLink>
            </li>
            <li className="nav-item">
              <HashLink smooth to="/#skills" duration={500} className="nav-link">
                Skills
              </HashLink>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/blogs">
                Blog
              </Link>
            </li>
            <li className="nav-item">
              <ScrollLink
                to="contact"
                smooth={true}
                duration={500}
                className="nav-link"
                style={{ cursor: "pointer" }}
              >
                Contact
              </ScrollLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
